/** Back from a hosted checkout whose payment is still pending (PayMongo settles by webhook only):
 * ask again this often, up to this many times, before leaving the page as it is. */
export const CHECKOUT_CONFIRM_POLL_MS = 3000;
export const CHECKOUT_CONFIRM_MAX_POLLS = 10;

/**
 * Self-serve payment (DEC-155). Mirrors `backend/app/core/constants/billing_methods.py` (checked by
 * `backend/tests/core/test_billing_methods_mirror.py`).
 *
 * ONE switch: which gateways and method kinds a workspace may NEWLY pay through. Today PayPal only
 * (owner decision, 2026-11-02); everything else is "Contact sales" and invoiced by hand. Re-enabling
 * PayMongo or Stripe is a one-line change here and in the backend constant; the console reads the
 * server's `allowed_gateways` first and falls back to this list. A method already saved on another
 * gateway keeps renewing.
 */
export const SELF_SERVE_GATEWAYS = ["paypal"] as const;
export const SELF_SERVE_METHOD_TYPES = ["paypal"] as const;
/** `subscriptions.billing_mode`: who collects the money. */
export const BILLING_MODES = ["gateway", "manual"] as const;
export type BillingModeKey = (typeof BILLING_MODES)[number];
/** Sales requests: status the platform admin moves, cycle, where the form was opened, bounds. */
export const SALES_REQUEST_STATUSES = ["new", "contacted", "done"] as const;
export type SalesRequestStatusKey = (typeof SALES_REQUEST_STATUSES)[number];
export const SALES_REQUEST_CYCLES = ["monthly", "annual"] as const;
export const SALES_REQUEST_SOURCES = ["plan", "institution", "pay_manually", "add_on"] as const;
export type SalesRequestSourceKey = (typeof SALES_REQUEST_SOURCES)[number];
export const SALES_REQUEST_NOTES_MAX = 4000 as const;
export const SALES_REQUEST_SEATS_MAX = 10000 as const;
export const SALES_REQUEST_ADDONS_MAX = 12 as const;
export const SALES_REQUEST_STAFF_NOTE_MAX = 2000 as const;
/** API error codes (`error.code`) of a refused method and of a workspace billed by invoice. */
export const PAYMENT_METHOD_DISABLED_CODE = "payment_method_disabled" as const;
export const BILLED_BY_INVOICE_CODE = "billed_by_invoice" as const;
